<div class="form-container">
  <div class="row form-group">
    <label class="col-sm-3 control-label">
      {{ 'revenue.credit-card-input.name-on-card-label' | translate | titlecase }}
    </label>
    <div [ngClass]="fieldCellCssClass">
      <input
        class="form-control"
        type="text"
        [(ngModel)]="value.CreditCardContactInfo.NameOnCard"
        (ngModelChange)="handleNameOnCardChange($event)"
      />
    </div>
  </div>

  <div class="row form-group">
    <label class="col-sm-3 control-label">
      {{ 'revenue.credit-card-input.credit-card-number-label' | translate | titlecase }}
    </label>
    <div [ngClass]="fieldCellCssClass">
      <div class="input-group">
        <wl-card-connect-input #cardConnectInput *ngIf="useCardConnect"></wl-card-connect-input>
        <!-- Preczn doesn't allow required/name/id on data-preczn fields, to keep this data from being swept up into the surrounding form's submission payload. -->
        <input data-preczn="number" #precznCardNumber class="form-control" *ngIf="usePreczn" />
        <input
          inputmode="numeric"
          pattern="[0-9]*"
          (input)="onCcNumChange($event)"
          (blur)="onCardNumberBlur()"
          type="text"
          *ngIf="!useCardConnect && !usePreczn"
          class="form-control"
          [style.border-color]="showCardNumberInvalid ? 'red' : null"
          [(ngModel)]="value.CardNum"
          (ngModelChange)="modelChange()"
          [attr.aria-invalid]="showCardNumberInvalid ? 'true' : null"
          [attr.aria-describedby]="showCardNumberInvalid ? 'ccNumberError' : null"
        />
        <span class="input-group-btn">
          <span class="col-sm-2">
            <img [hidden]="value.CardType != 'amex'" src="/assets/img/amex.gif" />
            <img [hidden]="value.CardType != 'discover'" src="/assets/img/disc.gif" />
            <img [hidden]="value.CardType != 'mastercard'" src="/assets/img/mastercard.gif" />
            <img [hidden]="value.CardType != 'visa'" src="/assets/img/visa.gif" />
          </span>
        </span>
      </div>
      <div class="text-danger" id="ccNumberError" role="alert" *ngIf="showCardNumberInvalid">
        {{ 'revenue.credit-card-input.credit-card-number-not-valid-validation-message' | translate }}
      </div>
    </div>
  </div>

  <div class="row form-group" *ngIf="!usePreczn">
    <label class="col-sm-3 control-label">
      {{ 'revenue.credit-card-input.security-code-label' | translate | titlecase }}
    </label>
    <div class="col-sm-3">
      <input type="text" [(ngModel)]="value.SecurityCode" (ngModelChange)="onFieldChange()" class="form-control" />
    </div>
  </div>
  <div class="row form-group" *ngIf="!usePreczn">
    <label class="col-sm-3 control-label">
      {{ 'revenue.credit-card-input.expires-label' | translate | titlecase }}
    </label>
    <div class="col-sm-6">
      <div class="form-inline">
        <select class="form-control" [(ngModel)]="value.ValidThruMonth" (ngModelChange)="validThruMonthChange($event)">
          <option *ngFor="let month of expireMonths" [selected]="month == value.ValidThruMonth ? true : null">
            {{ month }}
          </option>
        </select>

        <select class="form-control" [(ngModel)]="value.ValidThruYear" (ngModelChange)="validThruYearChange($event)">
          <option *ngFor="let year of expireYears" [selected]="year == value.ValidThruYear ? true : null">
            {{ year }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="row form-group" *ngIf="usePreczn">
    <label class="col-sm-3 control-label">
      {{ 'revenue.credit-card-input.security-code-label' | translate | titlecase }}
    </label>
    <div class="col-sm-3">
      <input data-preczn="cvv" #precznCvv class="form-control" />
    </div>
  </div>
  <div class="row form-group" *ngIf="usePreczn">
    <label class="col-sm-3 control-label">
      {{ 'revenue.credit-card-input.expires-label' | translate | titlecase }}
    </label>
    <div class="col-sm-6">
      <div class="form-inline">
        <select class="form-control" [(ngModel)]="value.ValidThruMonth" (ngModelChange)="validThruMonthChange($event)">
          <option *ngFor="let month of expireMonths" [selected]="month == value.ValidThruMonth ? true : null">
            {{ month }}
          </option>
        </select>

        <select class="form-control" [(ngModel)]="value.ValidThruYear" (ngModelChange)="validThruYearChange($event)">
          <option *ngFor="let year of expireYears" [selected]="year == value.ValidThruYear ? true : null">
            {{ year }}
          </option>
        </select>
      </div>
      <input data-preczn="expiration" [value]="precznExpirationValue" [hidden]="true" />
    </div>
  </div>

  <!--<div [ngClass]="fieldCellCssClass">
    </div>-->

  <div class="row form-group">
    <label class="col-sm-3">{{ 'common.personal-information.address1' | translate | titlecase }}</label>
    <div class="col-sm-6">
      <input class="form-control" type="text" [(ngModel)]="value.CreditCardContactInfo.Address1" (ngModelChange)="onFieldChange()" />
    </div>
  </div>
  <div class="row form-group">
    <label class="col-sm-3">{{ 'common.personal-information.address2' | translate | titlecase }}</label>
    <div class="col-sm-6">
      <input class="form-control" type="text" [(ngModel)]="value.CreditCardContactInfo.Address2" (ngModelChange)="onFieldChange()" />
    </div>
  </div>

  <div class="row form-group">
    <label class="col-sm-3" for="registrationCity">{{ 'revenue.credit-card-input.city-label' | translate | titlecase }}</label>
    <div class="col-sm-6">
      <input class="form-control" type="text" [(ngModel)]="value.CreditCardContactInfo.City" (ngModelChange)="onFieldChange()" />
    </div>
  </div>
  <div class="row form-group">
    <label class="col-sm-3" for="registrationState">{{ 'revenue.credit-card-input.state-label' | translate | titlecase }}</label>
    <div class="col-sm-6">
      <wl-state-selector [displayAbbreviation]="true" [(ngModel)]="value.CreditCardContactInfo.State" (ngModelChange)="onFieldChange()"></wl-state-selector>
    </div>
  </div>
  <div class="row form-group">
    <label class="col-sm-3" for="registrationZip">{{ 'revenue.credit-card-input.zip-label' | translate | titlecase }}</label>
    <div class="col-sm-3">
      <input class="form-control" type="text" [(ngModel)]="value.CreditCardContactInfo.Zip" (ngModelChange)="onFieldChange()" />
    </div>
  </div>
  <div class="row form-group">
    <label class="col-sm-3" for="registrationCountry">{{ 'revenue.credit-card-input.country-label' | translate | titlecase }}</label>
    <div class="col-sm-3">
      <input class="form-control" type="text" [(ngModel)]="value.CreditCardContactInfo.Country" (ngModelChange)="onFieldChange()" />
    </div>
  </div>
</div>
<div class="alert alert-danger" *ngIf="precznConfigError">
  {{ 'revenue.credit-card-input.preczn-config-error' | translate }}
</div>
